import { useQuery } from '@tanstack/react-query';
import { portalDb, type PortalInvoiceRow } from './portalClient';

export function usePortalInvoices(companyId: string | undefined) {
  return useQuery({
    queryKey: ['portal', companyId, 'invoices'],
    enabled: !!companyId,
    staleTime: 60_000,
    queryFn: async (): Promise<PortalInvoiceRow[]> => {
      const { data, error } = await portalDb
        .from('portal_invoices')
        .select('*')
        .eq('company_id', companyId)
        .order('created_at', { ascending: false })
        .limit(200);
      if (error) throw error;
      return (data ?? []) as PortalInvoiceRow[];
    },
  });
}

/** staleTime 0: a payment made in the Square tab should show on return. */
export function usePortalInvoice(companyId: string | undefined, invoiceId: string | undefined) {
  return useQuery({
    queryKey: ['portal', companyId, 'invoices', invoiceId],
    enabled: !!companyId && !!invoiceId,
    staleTime: 0,
    queryFn: async (): Promise<PortalInvoiceRow | null> => {
      const { data, error } = await portalDb
        .from('portal_invoices')
        .select('*')
        .eq('company_id', companyId)
        .eq('id', invoiceId)
        .maybeSingle();
      if (error) throw error;
      return (data as PortalInvoiceRow | null) ?? null;
    },
  });
}
